import { defineStore } from "pinia";

export const useCollectiviteManagementStore = defineStore("collectivite-management", {
    state: () => ({
        reloadVersion: 0,
    }),
    actions: {
        notifyReload() {
            this.reloadVersion++;
        },
    },
});